import React, { useEffect } from "react";

import { useTranslation } from "react-i18next";

import BaseLabel from "components/BaseLabel";
import Multiline from "components/Multiline";
import { Grid } from "@mui/material";

interface Props {
  serviceIntegrationNotification?: any;
  textFieldValue?: any;
  setTextFieldValue?: any;
  errorSIAuthent: any;
  setErrorSIAuthent: any;
}

const ServiceIntegrationNotification: React.FC<Props> = ({
  serviceIntegrationNotification,
  textFieldValue,
  setTextFieldValue,
  errorSIAuthent,
  setErrorSIAuthent,
}) => {
  const { t } = useTranslation();
  const handleTextFieldChange = (value: string) => {
    setTextFieldValue(value);
    try {
      JSON.parse(value);
      setErrorSIAuthent(null);
    } catch (errorSIAuthent) {
      setErrorSIAuthent(t("systemConfiguration.toasts.invalidJsonFixErrors"));
    }
  };

  useEffect(() => {
    setTextFieldValue(serviceIntegrationNotification);
  }, [serviceIntegrationNotification, setTextFieldValue]);

  return (
    <Grid container spacing={2} style={{ padding: "16px" }}>
      <Grid item xs={12}>
        <BaseLabel
          fontSize="18px"
          fontWeight="700"
          marginBottom="0px"
          marginTop="0px"
          marginLeft="0px"
          marginRight="0px"
          children={t("systemConfiguration.items.notificationParams")}
        />
      </Grid>
      <Grid item xs={12}>
        <Multiline
          label={t("systemConfiguration.parameters")}
          value={textFieldValue}
          onChange={handleTextFieldChange}
          error={!!errorSIAuthent}
          helperText={errorSIAuthent}
          name={"serviceIntegrationNotification"}
          rows={19}
        />
      </Grid>
    </Grid>
  );
};

export default ServiceIntegrationNotification;
